module.exports = __webpack_public_path__ + "img/1516355546.9335e9b0.jpg";